/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserIncidentFootageDtoFromJSON, UserIncidentFootageDtoToJSON, } from './UserIncidentFootageDto';
/**
 * Check if a given object implements the UserIncidentFootageDtoPageResponse interface.
 */
export function instanceOfUserIncidentFootageDtoPageResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function UserIncidentFootageDtoPageResponseFromJSON(json) {
    return UserIncidentFootageDtoPageResponseFromJSONTyped(json, false);
}
export function UserIncidentFootageDtoPageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': !exists(json, 'count') ? undefined : json['count'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(UserIncidentFootageDtoFromJSON)),
    };
}
export function UserIncidentFootageDtoPageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'totalCount': value.totalCount,
        'page': value.page,
        'pageSize': value.pageSize,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(UserIncidentFootageDtoToJSON)),
    };
}
